import { MenuItem } from '@mui/material';
import {
  useChangeLocale,
  useLocale,
  useToggleLocale,
} from '@pflegenavi/frontend/localization';
import {
  useUpdateUserProfile as useUpdateServiceProviderProfile,
  useUserProfile,
} from '@pflegenavi/service-provider-frontend/api';
import type { FC } from 'react';
import { useFeatureFlag } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag, FeatureFlagStatus } from '@pflegenavi/shared/api';
import { useCallback } from 'react';

export const renderSwitchLanguageMenuItem = ({
  handleClose,
}: {
  handleClose: () => void;
}): React.ReactElement => {
  return <SwitchServiceProviderLanguageMenuItem handleClose={handleClose} />;
};

const SwitchServiceProviderLanguageMenuItem: FC<{
  handleClose: () => void;
}> = ({ handleClose }) => {
  const locale = useLocale();
  const toggleLocale = useToggleLocale();
  const changeLocale = useChangeLocale();
  const { mutateAsync: updateLocale } = useUpdateServiceProviderProfile();

  const devToolsEnabled =
    useFeatureFlag(FeatureFlag.DevTools) === FeatureFlagStatus.Enabled;

  const { data: userProfile } = useUserProfile({});

  const switchLanguage = async () => {
    toggleLocale();
    await updateLocale({
      id: userProfile?.user.id ?? '',
      locale: locale === 'de-AT' ? 'en' : 'de',
    });
    handleClose();
  };

  const showTranslationKeys = useCallback(() => {
    changeLocale('cimode');
  }, [changeLocale]);

  const label =
    locale === 'de-AT' ? 'Zu Englisch wechseln' : 'Switch to German';

  if (devToolsEnabled) {
    return (
      <>
        <MenuItem onClick={switchLanguage}>{label}</MenuItem>
        <MenuItem onClick={showTranslationKeys}>Show translation keys</MenuItem>
      </>
    );
  }
  return <MenuItem onClick={switchLanguage}>{label}</MenuItem>;
};
